import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { IssueType, IssueStatus, CLSTAG } from '@/utils/constant';
import IssueApi from '@/fetch/bussiness/issue';
import { HttpStatusCode } from '@/fetch/core/constant';
import { useNavigate } from 'react-router-dom';
import CompleteIssueModal from '@/components/CompleteIssueModal';
import TransferIssueModal from '@/components/TransferIssueModal';
import { useSelector } from 'react-redux';
import OnHoldIssueModal from '@/components/OnHoldIssueModal';
import DiscardIssueModal from '@/components/DiscardIssueModal';
import { clstagStr, showMsg } from '@/utils/util';
import ReminderModal from '@/components/ReminderModal';
import { VehicleSupplier } from '@/utils/constant';

const RenderBottomBtn = ({
  issueInfo,
  isNotification,
}: {
  issueInfo: any;
  isNotification?: boolean;
}) => {
  const fetchApi = new IssueApi();
  const navigator = useNavigate();

  const { login, issueList, cockpitInfo } = (window as any).store.getState();
  const { cockpitTeamNumber, currentCockpit } = useSelector(
    (state: any) => state.cockpitInfo
  );
  const isHasProcess =
    issueList &&
    issueList.filter((val: any) => val.issueStatus === IssueStatus.PROCESS);
  const [openCompleteIssueModal, setOpenCompleteIssueModal] = useState(false);
  const [remindReportModal, setRemindReportModal] = useState(false);
  const [openTransferIssueModal, setOpenTransferIssueModal] = useState(false);
  const [openOnHoldIssueModal, setOpenOnHoldIssueModal] = useState(false);
  const [holdIssueModalType, setHoldIssueModalType] = useState<
    'HOLD' | 'CANCEL_HOLD'
  >('HOLD');
  const [openDiscardIssueModal, setOpenDiscardIssueModal] = useState(false);

  /**
   * 接单
   */
  const handleAcceptIssue = async () => {
    const res = await fetchApi.acceptIssue({
      issueNumber: issueInfo?.issueNumber,
      cockpitNumber: cockpitInfo.currentCockpit.cockpitNumber,
      acceptUsername: login.user.username,
    });
    if (res.code === HttpStatusCode.Success) {
      fetchApi.cancelNewIssue(
        [issueInfo?.issueNumber],
        currentCockpit.cockpitNumber
      );
      if (issueInfo?.issueType === IssueType.OPS) {
        window.open(
          `/app/single?license=${issueInfo?.vehicleName}&tabKey=threeDimension&source=ticket`,
          '_blank'
        );
      } else if (issueInfo?.issueType === IssueType.PROBLEM_REPORT) {
        navigator('/app/shadowsystem');
      }
    }
  };

  /**
   * 查看工单
   */
  const handleCheckIssue = () => {
    fetchApi.cancelNewIssue(
      [issueInfo?.issueNumber],
      currentCockpit.cockpitNumber
    );
    if (issueInfo?.issueType === IssueType.OPS) {
      window.open(
        `/app/single?license=${issueInfo?.vehicleName}&tabKey=threeDimension&source=ticket`,
        '_blank'
      );
    } else if (issueInfo?.issueType === IssueType.PROBLEM_REPORT) {
      navigator('/app/shadowsystem');
    }
  };
  /**
   * 挂单
   */
  const handleHoldIssue = async () => {
    setHoldIssueModalType('HOLD');
    setOpenOnHoldIssueModal(true);
  };
  /**
   * 取消挂单
   */
  const handelCancelHoldIssue = async () => {
    setHoldIssueModalType('CANCEL_HOLD');
    setOpenOnHoldIssueModal(true);
  };
  /**
   * 点击抛单按钮
   */
  const handleDiscardIssue = () => {
    setOpenDiscardIssueModal(true);
  };

  /**
   * 点击转单按钮
   */
  const handleTransferIssue = async () => {
    setOpenTransferIssueModal(true);
  };

  /**
   * 点击结单按钮
   */
  const handleCompleteIssue = () => {
    getCurrentIssueEventInfo();
  };
  const getCurrentIssueEventInfo = async () => {
    try {
      const res = await fetchApi.getIssueEvent({
        issueNumber: issueInfo.issueNumber,
      });
      if (res.code === HttpStatusCode.Success) {
        if (res.data.accidentProcessed) {
          setOpenCompleteIssueModal(true);
        } else {
          setOpenCompleteIssueModal(false);
          setRemindReportModal(true);
        }
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const renderBtns = () => {
    if (issueInfo.emergencyIssue) {
      return (
        <Button type="primary" onClick={handleAcceptIssue}>
          受理（将挂起正处理的工单）
        </Button>
      );
    }
    if (issueInfo.issueStatus === IssueStatus.PROCESS && isNotification) {
      return (
        <Button
          onClick={handleCheckIssue}
          clstag={clstagStr(CLSTAG.IssueNotificationToSingle)}
        >
          查看详情
        </Button>
      );
    }
    const btnMap: any = {
      'PROCESS+OPS': (
        <>
          <Button
            onClick={handleHoldIssue}
            clstag={clstagStr(CLSTAG.IssueCardHold)}
          >
            挂单
          </Button>
          <Button
            onClick={handleDiscardIssue}
            clstag={clstagStr(CLSTAG.IssueCardDiscard)}
          >
            抛单
          </Button>
          <Button
            onClick={handleTransferIssue}
            clstag={clstagStr(CLSTAG.IssueCardTransfer)}
          >
            转单
          </Button>
          <Button
            type="primary"
            onClick={handleCompleteIssue}
            clstag={clstagStr(CLSTAG.IssueCardComplete)}
          >
            结单
          </Button>
        </>
      ),
      [`PROCESS+${IssueType.PROBLEM_REPORT}`]: (
        <>
          <Button
            onClick={handleHoldIssue}
            clstag={clstagStr(CLSTAG.IssueCardHold)}
          >
            挂单
          </Button>
          <Button
            type="primary"
            onClick={handleCompleteIssue}
            clstag={clstagStr(CLSTAG.IssueCardComplete)}
          >
            结单
          </Button>
        </>
      ),
      [`ON_HOLD+${IssueType.PROBLEM_REPORT}`]: (
        <Button type="primary" onClick={handelCancelHoldIssue}>
          {isHasProcess ? '取消挂单（将挂起正处理的工单）' : '取消挂单'}
        </Button>
      ),
      'ON_HOLD+OPS': (
        <>
          <Button
            onClick={handleDiscardIssue}
            clstag={clstagStr(CLSTAG.IssueCardDiscard)}
          >
            抛单
          </Button>
          <Button
            onClick={handleTransferIssue}
            clstag={clstagStr(CLSTAG.IssueCardTransfer)}
          >
            转单
          </Button>
          <Button type="primary" onClick={handelCancelHoldIssue}>
            {isHasProcess ? '取消挂单（将挂起正处理的工单）' : '取消挂单'}
          </Button>
        </>
      ),
    };
    return btnMap[`${issueInfo?.issueStatus}+${issueInfo?.issueType}`];
  };

  return (
    <>
      {renderBtns()}

      <CompleteIssueModal
        open={openCompleteIssueModal}
        setOpen={setOpenCompleteIssueModal}
        issueNumber={issueInfo.issueNumber}
        vehicleName={issueInfo.vehicleName}
        // 结单弹窗内部需要车辆供应商字段做逻辑判断，此入口产生的工单只有自研车才有，所以需要传入默认值
        vehicleSupplier={VehicleSupplier.JD}
      />

      <TransferIssueModal
        open={openTransferIssueModal}
        setOpen={setOpenTransferIssueModal}
        vehicleName={issueInfo.vehicleName}
        type="TRANSFER"
      />

      {openOnHoldIssueModal && (
        <OnHoldIssueModal
          open={openOnHoldIssueModal}
          setOpen={setOpenOnHoldIssueModal}
          issueNumber={issueInfo.issueNumber}
          type={holdIssueModalType}
        />
      )}
      <DiscardIssueModal
        open={openDiscardIssueModal}
        setOpen={setOpenDiscardIssueModal}
        vehicleName={issueInfo.vehicleName}
      />
      <ReminderModal
        vehicleName={issueInfo.vehicleName}
        remindReportModal={remindReportModal}
        setRemindReportModal={setRemindReportModal}
      />
    </>
  );
};

export default React.memo(RenderBottomBtn);
